module.exports = __webpack_public_path__ + "resources/icon_50_back.56c16abdc8bcff09.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_back.png
// module id = 464
// module chunks = 0 1 2 3 4